<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-toolbar flat class="transparent display-1">
          Dešavanja
        </v-toolbar>
        <v-list two-line>
          <template v-for="(message, index) in messages">
            <v-list-tile :key="message.id" @click="open(message)">
              <v-list-tile-content>
                <v-list-tile-title>{{ title(message) }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{ deliveryInfo(message) }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="index + 1 < messages.length"></v-divider>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import 'moment/locale/sr'
import auth from '@/services/authService.js'
import userService from '@/services/userService.js'
export default {
  data () {
    return {
      user: auth.getCurrentUser(),
      messages: userService.getMessages()
    }
  },
  methods: {
    title (message) {
      switch (message.type) {
        case 'apply':
          return 'Prijava na dostavu je uspela'
        case 'apply-failed':
          return 'Prijava na dostavu nije uspela'
        case 'pickup':
          return 'Dostava je preuzeta'
        case 'finish':
          return 'Dostava je završena'
        case 'cancel':
          return 'Dostava je otkazana'
        case 'comment':
          return 'Nova poruka na dostavi'
        case 'pickup-reminder':
          return 'Podsetnik za preuzimanje dostave'
        case 'finish-reminder':
          return 'Podsetnik da dostavu treba isporučiti'
        default:
          return ''
      }
    },
    deliveryInfo (delivery) {
      if (delivery.from_address) {
        return `${delivery.from_name} (${delivery.from_address}) → ${delivery.to_address}`
      } else {
        return ``
      }
    },
    formatDate (d) {
      return d ? moment(d).format('Do MMMM YYYY, h:mm:ss') : ''
    },
    open (message) {
      console.log(message)
      if (message.delivery_id) {
        this.$router.push(`/delivery/${message.delivery_id}`)
      }
    }
  }
}
</script>
